export default __webpack_public_path__ + "media/mnc.8c4d8789.png";